import { AddressContract } from '../../types/Address';
import {
  AddressVerificationContract,
  AddressVerificationRequestBody,
  AddressVerificationResponseBody,
  IAddressVerificationService,
} from '../../types/AddressValidation';
import { AddressVerificationServiceConfig } from '../../types/ServiceConfigurations';
import { Endpoints } from '../../utils/constants';

class AddressVerificationService implements IAddressVerificationService {
  private apiUrl: string;

  constructor(config: AddressVerificationServiceConfig) {
    this.apiUrl = config.apiUrl;
  }

  public verify = async (
    address: AddressContract
  ): Promise<AddressVerificationContract> => {
    const { address1, address2, city, state, country, postalCode } = address;

    const requestBody: AddressVerificationRequestBody = {
      address1,
      locality: city,
      administrativeArea: state,
      postalCode,
      country,
    };
    if (address2) {
      requestBody.address2 = address2;
    }

    const response = await fetch(
      `${this.apiUrl}${Endpoints.ADDRESS_VERIFICATION}`,
      {
        method: 'POST',
        headers: {
          'Content-type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      }
    );

    if (!response.ok) {
      return Promise.reject(
        new Error(`${response.status}: ${response.statusText}`)
      );
    }

    const result: AddressVerificationResponseBody = await response.json();

    const output: AddressVerificationContract = {
      address1: result.address1,
      city: result.locality,
      state: result.administrativeArea,
      country: result.country,
      verificationStatus: result.verificationStatus,
      recommendations: result.recommendations ?? [],
    };

    if (result.address2) {
      output.address2 = result.address2;
    }
    if (result.postalCode) {
      output.postalCode = result.postalCode;
    }

    return output;
  };
}

export default AddressVerificationService;
